const overlay = ID["modal-overlay"];
if (overlay) {
    document.addEventListener('click', e => {
       if (e.target.id === 'modal-overlay' || e.target.id === 'modal-close') {
           overlay.style.display = "none";
           const date = new Date();
           date.setTime(date.getTime() + (e.target.dataset.hours*60*60*1000))
           document.cookie = "modalChangeLang=true;expires=" + date.toUTCString() + ";path=/";

       }

    });
    /*overlay.addEventListener('click', (e) => {


    });*/
}